import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <div className="min-h-screen bg-black text-white pt-24">
      <div className="max-w-4xl mx-auto px-6 py-16">
        {/* Who We Are */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-20"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-8">Who We Are</h2>
          <p className="text-white/70 text-lg leading-relaxed mb-6">
            Neufora is a pioneering technology company at the intersection of artificial intelligence and robotics. We are a team of visionaries, engineers, and innovators committed to building intelligent systems that transform how machines understand and interact with the world.
          </p>
          <p className="text-white/70 text-lg leading-relaxed">
            Founded on the principle that technology should amplify human potential, we develop cutting-edge solutions that push the boundaries of what's possible in AI and autonomous systems.
          </p>
        </motion.section>

        {/* What We Do */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mb-20"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-8">What We Do</h2>
          <p className="text-white/70 text-lg leading-relaxed mb-6">
            We design and develop advanced AI architectures, neural processing systems, and autonomous robotics platforms. Our work spans from fundamental research in machine learning to practical applications that solve real-world challenges.
          </p>
          <p className="text-white/70 text-lg leading-relaxed mb-6">
            Our flagship platform, SerumAI, represents a breakthrough in intelligent systems—combining adaptive learning, real-time processing, and contextual understanding to create machines that think and respond with unprecedented sophistication.
          </p>
          <p className="text-white/70 text-lg leading-relaxed">
            From neural chips to humanoid robots, every product we create is built with precision, purpose, and a commitment to advancing the field of artificial intelligence.
          </p>
        </motion.section>

        {/* Our Mission */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-8">Our Mission</h2>
          <p className="text-white/70 text-lg leading-relaxed mb-6">
            Our mission is to shape the future of technology by creating artificial intelligence systems that are not only powerful but also responsible, accessible, and beneficial to humanity.
          </p>
          <p className="text-white/70 text-lg leading-relaxed mb-6">
            We believe in building technology that empowers people, enhances productivity, and opens new frontiers of innovation. Through rigorous research, ethical development practices, and a relentless pursuit of excellence, we aim to be at the forefront of the AI revolution.
          </p>
          <p className="text-white/70 text-lg leading-relaxed">
            At Neufora, we're not just developing machines—we're engineering tomorrow's technology, today.
          </p>
        </motion.section>
      </div>
    </div>
  );
};

export default About;